<span class="header-brand" [class.header-brand--name-visible]="nameAlwaysVisible">
  <!-- Il nome e' scritto accanto, anche quando sul telefono non si vede: il marchio tace. -->
  <dxp-brand-mark
    class="header-brand__mark"
    variant="header"
    [initials]="initials"
    [imageUrl]="markUrl"
  />
  <span class="header-brand__name">{{ name }}</span>
</span>
